<template>
  <div v-cloak>
    <div class="flex w-full">
      <div
        class="vx-col sm:w-1/3 w-full mb-2"
       
      >
        <vs-button
          @click="showBaseSalePricePopup()"
          class="vs-component vs-button bg_l_green"
           v-has-permission="'CreateBaseSalePrice'"
        >
          <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="ico" />درج
          {{ $t("BaseSalePrice") }}
        </vs-button>
        <vs-button
          @click="showUpdatePricePopup()"
          v-has-permission="'AssignBaseSalePriceItems'"
          class="vs-component vs-button bg_l_green mr-5"
        >
          {{ $t("UpdatePrice") }}
        </vs-button>
      </div>
    </div>
    <div class="flex w-full flex-wrap gap-y-4">
      <div class="flex-grow">
        <vs-input
          :label="$t('ItemCode')"
          v-model="gridSearchData.itemCode"
          @keyup.enter="submitFilter"
          v-trim-space
        />
      </div>
      <div class="flex-grow flex justify-end items-end gap-4">
        <vs-button type="filled" color="#3ec9d6" @click.prevent="resetForm">{{
          $t("ResetFilter")
        }}</vs-button>
        <vs-button type="filled" @click.prevent="submitFilter">{{
          $t("SubmitFilter")
        }}</vs-button>
      </div>
    </div>
    <div class="vx-row pt-4">
      <div class="vx-col w-full mb-base">
        <data-grid
          ref="grid"
          stripe
          :data-source="gridDataSource"
          :search-data="gridSearchData"
          :columns="[{ title: $t('ItemCode') }, { title: $t('Price') }]"
        >
          <template slot-scope="{ row }">
            <td style="width: 50%">
              {{ row.itemCode }}
            </td>
            <td style="width: 50%">
              {{ row.price.toLocaleString() }}
            </td>
          </template>
        </data-grid>
      </div>
    </div>

    <base-sale-price-popup
      :show="baseSalePricePopup"
      :model="modalModel"
      @close="closeBaseSalePricePopup"
      @finish="baseSalePricePopupFinish"
    ></base-sale-price-popup>
    <update-price-popup
      :show="updatePricePopup"
      :model="modalModel"
      :contractId="contractId"
      @close="closeBaseSalePricePopup"
      @finish="baseSalePricePopupFinish"
    ></update-price-popup>
  </div>
</template>

<script>
import { mapActions } from "vuex";

import DataGrid from "@/components/datagrid/DataGrid";
import BaseSalePricePopup from "../BaseSalePricePopup.vue";
import UpdatePricePopup from "../UpdatePricePopup.vue";

export default {
  name: "saleManagement_Contract_Management_BaseSalePrice",
  components: {
    DataGrid,
    BaseSalePricePopup,
    UpdatePricePopup,
  },
  data() {
    var id = this.$route.params.id;

    return {
      gridDataSource: {
        type: "app",
        service: `/Sales/api/BaseSalePriceQuery/${id}/items`,
      },
      contractId:id,
      price:'',
      gridSearchData: {},
      modalModel: {},
      model: {},
      baseSalePricePopup: false,
      updatePricePopup: false,
      selectedProducts: [],

    };
  },
  mounted() {},

  methods: {


    submitFilter() {
      this.$refs.grid.renderGrid(1, true);
    },
    resetForm() {
      this.gridSearchData = {};
      setTimeout(() => {
        this.$refs.grid.renderGrid(1, true);
      }, 10);
    },
    showBaseSalePricePopup() {
      this.modalModel = { contractId: Number(this.$route.params.id) };
      this.baseSalePricePopup = true;
    },
    showUpdatePricePopup() {
      this.modalModelPrice = { contractId: Number(this.$route.params.id) };

      this.updatePricePopup = true;
    },
    closeBaseSalePricePopup() {
      this.modalModel = {};
      this.modalModelPrice = {};
      this.baseSalePricePopup = false;
      this.updatePricePopup = false;
    },
    baseSalePricePopupFinish() {
      this.closeBaseSalePricePopup();
      this.$refs.grid.renderGrid();
    },
  },
};
</script>

<style scoped></style>
